document.addEventListener('DOMContentLoaded', function() {
  // Initialize all shop by category swipers
  const swiperContainers = document.querySelectorAll('.shop-by-category-swiper');
  
  swiperContainers.forEach((container) => {
    const sectionId = container.dataset.sectionId;
    
    new Swiper(container, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      },

      navigation: {
        nextEl: `[data-section-id="${sectionId}"] .swiper-button-next`,
        prevEl: `[data-section-id="${sectionId}"] .swiper-button-prev`,
      },
      grabCursor: true,
    });
  });
});
